// STEP 11d · A9 (#116 find 30, Claude's call: "Send saves the row first") — one click on "Send to misstatements" on a CHANGED
// row: the row is saved first (its own draft only, through the worksheet's own row save); if the save succeeds it is sent; if
// the save fails the save error is shown (on the row and in a toast) and nothing is sent. A row with no change is sent at once.
// Used by every worksheet with row drafts and a per-row send (the list is in the Step 11d report, lane D1b).
import { toast } from "sonner";
import I18N from "@/lib/i18n/1995_s11d1b_finance";

const T = (lang) => I18N[lang === "ar" ? "ar" : "en"].s11d1b.send;

export function saveFailedText(msg, lang = "en") {
  return T(lang).saveFailed.replace("{msg}", msg || "");
}

/** Resolves true when the row has no change or its save succeeded (go on and send), false when the save failed. */
export async function saveRowFirst(td, id, lang = "en") {
  if (!td || typeof td.isChanged !== "function" || !td.isChanged(id)) return true;
  const r = await td.saveOne(id);
  if (r && r.ok) return true;
  toast.error(saveFailedText(r && r.error, lang));
  return false;
}
